<template>
  <div :class="$style.container">
    <CategoryItem
      v-for="category in categories"
      :key="category"
      :class="$style.category"
      :category="category"
      :icon="icons[category]"
      :label="$t(`views.categories.${category}`)"
      :is-active="selectedCategories.includes(category)"
      @click="onToggle(category)"
    />

    <transition name="t-fade">
      <div
        v-if="isNetguruMode"
        :class="$style.specialCategory"
        data-test="secret-category"
        @click="onToggle(secretCategory)"
      >
        <NetguruLogo :class="$style.specialCategoryIcon" />
        <img
          src="/img/travolta.gif"
          :class="$style.specialCategoryGif"
        >
      </div>
    </transition>
  </div>
</template>

<script>
import DesignIcon from '@/assets/design.svg';
import ITIcon from '@/assets/it.svg';
import PeopleIcon from '@/assets/people.svg';
import TravelIcon from '@/assets/travel.svg';
import NetguruLogo from '@/assets/netguru.svg';
import CategoryItem from '@/components/CategoryItem/CategoryItem';
import { secretCategory } from '@/consts';

const icons = {
  design: DesignIcon,
  it: ITIcon,
  people: PeopleIcon,
  travel: TravelIcon,
};

export default {
  components: {
    CategoryItem,
    /* eslint-disable vue/no-unused-components */
    DesignIcon,
    ITIcon,
    PeopleIcon,
    TravelIcon,
    /* eslint-enable vue/no-unused-components */
    NetguruLogo,
  },

  props: {
    categories: {
      type: Array,
      required: true,
    },
    selectedCategories: {
      type: Array,
      default: () => [],
    },
    isNetguruMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      icons,
      secretCategory,
    };
  },

  methods: {
    onToggle(category) {
      const isActive = this.selectedCategories.includes(category);
      this.$_playSound(isActive ? 'unclick' : 'click');
      this.$emit('onToggle', category);
    },
  },
};
</script>

<style module lang="scss">
  .container {
    position: relative;
    display: flex;
    margin-top: 20px;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .category {
    height: 155px;
    max-height: 37vw;
    margin-bottom: 15px;
    flex-basis: calc(50% - 7.5px);

    @media #{$mobile-sm-down} {
      height: 115px;
    }
  }

  .specialCategory {
    @include absolute(top 0 left 0 right 0 bottom 15px);

    z-index: $z-index-1;
    display: flex;
    width: 100%;
    border-radius: 15px;
    background-color: $c-white;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    &Icon {
      width: 160px;
      margin: auto;
    }

    &Gif {
      width: 40%;
    }
  }
</style>
